import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: string;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: undefined,
};

const getSignatureSlice = createSlice({
  name: "getSignature",
  initialState,
  reducers: {
    getSignatureStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getSignatureSuccess: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getSignatureFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetSignature: () => {
      return { ...initialState };
    },
  },
});

export const {
  getSignatureStart,
  getSignatureSuccess,
  getSignatureFailed,
  resetSignature,
} = getSignatureSlice.actions;

export default getSignatureSlice.reducer;
